import { FC } from 'react';
import { useField, useFormikContext } from 'formik';
import { CustomerSelect } from 'src/Controls';
import { FieldControl } from 'src/UI';
import { IBaseField } from './BaseField';

interface ICustomerProps extends IBaseField {
	setData: Function;
}

const Customer: FC<ICustomerProps> = ({
	name,
	placeholder,
	disabled = false,
	title,
	isRequired = false,
	excludeCurrentCustomer = false,
	setData,
}) => {
	const [inputProps, meta, helpers] = useField(name);
	const { values } = useFormikContext<{ recId?: string | null }>();
	const excludedIds =
		excludeCurrentCustomer && values.recId ? [values.recId] : [];

	const onChangeHandler = (value = '') => {
		helpers.setTouched(true);
		helpers.setValue(value, true);
		!!setData &&
			setData((data: any) => {
				return { ...data, [name]: value };
			});
	};

	return (
		<FieldControl
			name={name}
			title={title}
			isRequired={isRequired}
			isInvalid={!!meta.touched && !!meta.error}
			isTouched={meta.touched}
			errorMsg={meta.error}
		>
			<CustomerSelect
				disabled={disabled}
				placeholder={placeholder}
				value={inputProps.value}
				setValue={(v) => {
					return onChangeHandler(v?.id);
				}}
				showClearBtn
				invalidate={!!(meta.touched && meta.error)}
				excludedIds={excludedIds}
			/>
		</FieldControl>
	);
};

export default Customer;
